export const signaturesKeys = {
	all: ['signatures'],
	list: () => ['signatures', 'list'],
	detail: (id) => ['signatures', 'detail', id],
};
